<template>
  <hub-form class="form" messageBox="absolute" v-slot:formcontent :onSubmit="savePassword">

    <div class="logo">
      <img src="/logo.png" />
      <h2>X-CUBE</h2>
    </div>

    <h2>Enter your email</h2>
    <h5>To receive a mail with a reset link</h5>

    <input placeholder="email" type="email" v-model="model.email" maxLength="64" minLength="5" required />
    <button @submit.prevent>Reset password</button>
    <router-link to="/login">
      Back to login
    </router-link>
  </hub-form>
</template>

<script setup>
import { Message } from "element-ui";
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import { sendResetPasswordEmail } from "../../api/rest";
import HubForm from "../shared/Form.vue";

const router = useRouter();

const model = ref({
  email: "",
});

const loading = ref(false);

const savePassword = async () => {
  loading.value = true;
  try {
    await sendResetPasswordEmail(model.value.email);

    loading.value = false;
    Message.success("Request sent. Please check your email.");
    router.push("/login");
  } catch (error) {
    console.error(error);
    Message.error("Failed to contact the server, please try again later");
    loading.value = false;
  }
};
</script>

<style scoped lang="scss">
.form {
  background-color: black;
  display: flex;
  margin: auto;
  width: 290px;
  padding: 20px;

  box-shadow: 0 0 20px black;
  border-radius: 5px;

  input {
    margin: auto;
  }

  button,
  h2 {
    margin: auto;
  }

  h2 {
    margin: 20px auto 0px auto;
  }

  h5 {
    margin: 0px 0px 24px 0px;
  }

}

form:not(.el-form) {
  button {
    margin-top: 24px;
    cursor: pointer;
  }
}

img {
  height: 64px;
}
</style>
